

































import { Prop, Component, Vue } from 'vue-property-decorator'
import { EventLogAPI } from '@/api/backend-client'
import { EventLog } from '@/api/model/event-log'
import { Contact } from '@/api/model/contact'
import { Referral } from '@/api/model/referral'

@Component
export default class ActivityLog extends Vue {
    @Prop() readonly contact!: Contact
    @Prop() readonly referral!: Referral
    eventLogs: EventLog[] = []
    loading: boolean = false

    async mounted() {
        if (this.contact || this.referral) {
            this.eventLogs = Array.from(new Set([
                ...this.contact.eventLogs,
                // ...this.referral.eventLogs,
            ]))
        } else {
            this.loading = true
            const result = await EventLogAPI.getPaged({})
            this.eventLogs = result.collection
            this.loading = false
        }
    }

    // Fairly hacky way, but a small step towards individual rendering of event types
    formatActivityEvent(log: EventLog) {
        switch (log.event) {
            case 'EmailSentEvent':
                return this.$t(`activity.${log.event}`, { user: log.name }) +
                    `: ${log.eventData.subject}`
            case 'ReferralStatusChangedEvent': {
                let status = this.$t(`referral.status.${log.eventData.status}`)
                if (log.eventData.statusReason) {
                    status += ' (' + this.$t(`referral.statusReason.${log.eventData.statusReason}`) + ')'
                }

                if (log.eventData.newStatusReason && log.eventData.status !== 'open') {
                    status += ' (' + log.eventData.newStatusReason + ')'
                }

                return this.$t(`activity.${log.event}`, {
                    user: log.name,
                    pipelineName: log.pipelineName || 'onbekend',
                    status,
                })
            }
            case 'ReferralPhaseChangedEvent': {
                let result = this.$t(`activity.${log.event}`, {
                    user: log.name,
                    pipelineName: log.pipelineName || 'onbekend',
                    phase: log.eventData.phase,
                })

                if (log.eventData.newStatusReason) {
                    result += ' (' + log.eventData.newStatusReason + ')'
                }

                return result
            }
            case 'ReferralChannelChangedEvent': {
                const channel = this.$t(`referral.channel.${log.eventData.channel}`)

                return this.$t(`activity.${log.event}`, {
                    user: log.name,
                    pipelineName: log.pipelineName || 'onbekend',
                    channel,
                })
            }
            case 'ReferralSourceChangedEvent': {
                return this.$t(`activity.${log.event}`, {
                    user: log.name,
                    pipelineName: log.pipelineName || 'onbekend',
                    source: log.eventData.source,
                })
            }
            default:
                return this.$t(`activity.${log.event}`, {
                    user: log.name,
                    pipelineName: log.pipelineName || 'onbekend',
                })
        }
    }

    get sortedEventLogs(): EventLog[] {
        return this.eventLogs
            .sort((a: EventLog, b: EventLog) => a.loggedAt > b.loggedAt ? -1 : 1)
    }

    get widgetAvatarSvg(): string[] {
        return [
            'brunette-circle',
            'blond-circle',
            'sylvana-circle',
        ]
    }

    // maybe later
    // async routeToDetail(log: EventLog) {
    //     if(log.referral) {
    //         await this.$router.push({
    //             name: 'tasks_detail',
    //             params: {
    //                 referralId: log.referral.id,
    //             }
    //         })
    //     }
    // }

    get virtualColleagueEnabled(): boolean {
        return !!this.$currentCompany.virtualColleagueAvatar
    }

    get userName(): string {
        return this.$currentCompany.virtualColleagueName
    }

    get userAvatar(): string {
        return require('@/assets/img/avatar/' + this.$currentCompany.virtualColleagueAvatar + '.jpg')
    }
}
